import { useCallback } from "react";

import { usePromise } from "@touchtech/web-hooks";

import { useManageApiHeaders } from "@is/hooks/useManageApiHeaders";
import { api, createCheckoutConfigurationsValidationUrl } from "@is/services";
import { ValidateOrder } from "@is/types";

type ExtendedError = Error & { body: { message: string; name: string }[] };

type ValidationResponse = {
  text: string;
};

type State = {
  isPending: boolean;
  error: ExtendedError | null;
  data: ValidationResponse | null;
};

async function handleValidateCheckoutForm(
  params: ValidateOrder
): Promise<ValidationResponse> {
  const url = createCheckoutConfigurationsValidationUrl();

  const data = (await api.post(url, params)) as ValidationResponse;

  return data;
}

export const useValidateCheckoutForm = (): [
  State,
  (params: ValidateOrder) => Promise<ValidationResponse>
] => {
  const { setApiHeaders } = useManageApiHeaders();

  setApiHeaders();

  const [{ isPending, error, data }, dispatch] =
    usePromise<ValidationResponse>();

  const validateCheckoutForm = useCallback(
    (params: ValidateOrder) => dispatch(handleValidateCheckoutForm(params)),
    [dispatch]
  );

  return [
    { isPending, error: error as ExtendedError, data },
    validateCheckoutForm,
  ];
};
